import { PageLayout } from '../components/PageLayout';
import { PolicySection } from '../components/sections/PolicySection';

export const Factory = () => (
    <PageLayout>
        <PolicySection />
    </PageLayout>
);
